<template>
	<PageTitleComponent>You're Lost</PageTitleComponent>

	<section class="band">
		<h2>Whoops!</h2>
		<p>What you're looking for can't be found.</p>
		<p v-if="canAccessResources">
			If you were looking for a resource, go to
			<router-link
				:to="{
					name: 'resourceList',
				}"
			>
				resources
			</router-link>
			and search for it.
		</p>
		<p v-else>Please check the link and try again.</p>
	</section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageTitleComponent from '@/components/shared/PageTitleComponent.vue';
import { useUser } from '@/stores/userStore';
import { mapState } from 'pinia';

export default defineComponent({
	components: { PageTitleComponent },
	computed: {
		...mapState(useUser, ['canAccessResources']),
	},
});
</script>

<style scoped lang="scss">
h2 {
	margin-bottom: 1rem;
	font-size: 32px;
}
</style>
